module.exports = __webpack_public_path__ + "bd46fd0f42b24a9133fc1a4be9a3da36.png";